<template>
  <div>
    <!-- Mobile View -->
    <div class="md:hidden">
      <!-- Black Friday Tag -->
      <div class="bg-black py-3">
        <div class="flex items-center justify-center gap-2 text-white">
          <div class="flex items-center gap-2 text-sm font-medium animate-pulse">
            <span class="text-yellow-300">🔥</span>
            <span class="uppercase tracking-wider font-semibold">Black Friday</span>
            <span class="countdown-text font-mono">{{ countdownText }}</span>
          </div>
        </div>
      </div>

      <!-- Logo Container -->
      <div class="bg-[#F6F4F0] py-4 px-4">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/dark-numerology-prod.firebasestorage.app/o/assets%2Fimages%2Flogo-white.png?alt=media&token=e7e6f43a-5880-42bc-bff6-136607976afe"
          alt="Mistérios do Destino" width="120" height="30"
          class="h-7 w-auto object-contain mx-auto"
        />
      </div>
    </div>

    <!-- Desktop View -->
    <div class="hidden md:block bg-gradient-to-r from-black via-gray-900 to-black text-white">
      <div class="max-w-6xl mx-auto py-2 px-4">
        <div class="flex items-center justify-between">
          <!-- Black Friday Tag -->
          <div class="flex items-center gap-3 min-w-[200px]">
            <div class="flex items-center gap-2 bg-red-600 px-3 py-1 rounded-full text-sm font-medium animate-pulse">
              <span class="text-yellow-300">🔥</span>
              <span>BLACK FRIDAY</span>
            </div>
            <span class="countdown-text font-mono text-lg">{{ countdownText }}</span>
          </div>

          <!-- Logo -->
          <img
            src="https://firebasestorage.googleapis.com/v0/b/dark-numerology-prod.firebasestorage.app/o/assets%2Fimages%2Fmisterios-white-logo.svg?alt=media&token=615f39f8-2684-4e93-ad05-01e98a3f62e6"
            alt="Mistérios do Destino" width="60" height="28"
            class="h-5 w-auto object-contain mx-4"
          />

          <!-- Reviews -->
          <div class="flex items-center gap-3 min-w-[200px] bg-white/10 px-4 py-2 rounded-full">
            <div class="flex items-center gap-2">
              <span class="font-medium">Excelente</span>
              <div class="flex text-[#00b67a]">★★★★★</div>
            </div>
            <div class="h-4 w-px bg-white/20"></div>
            <span><b>436</b> avaliações no <b>Trustpilot</b></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const countdownText = ref('')

const updateCountdown = () => {
  const now = new Date()
  const target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
  const difference = target.getTime() - now.getTime()

  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((difference % (1000 * 60)) / 1000)

  countdownText.value = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

onMounted(() => {
  updateCountdown()
  setInterval(updateCountdown, 1000)
})
</script>

<style scoped>
.countdown-text {
  font-variant-numeric: tabular-nums;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>